export const pipeAll = (...fns) => x => fns.reduce((v, f) => f(v), x);

export const replace = (s1 = '', s2 = '') => param => param.replace(s1, s2);

export const concat = val => param => [...param, ...val];

export const join = (val = '') => param => param.join(val);

export const toUpper = () => param => param.toUpperCase();

export const thru = (fn = x => x) => param => fn(param);

export const get = path => (obj = null) => {
  if (!obj) return {};
  const travel = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? {} : result;
};

export const omit = (arr = []) => (obj = null) => {
  if (!obj) return {};

  return Object.keys(obj)
    .filter(key => !arr.includes(key))
    .reduce((newObj, key) => {
      // eslint-disable-next-line no-param-reassign
      newObj[key] = obj[key];
      return newObj;
    }, {});
};
